import React, { useState, useMemo, useCallback, useEffect, useRef } from 'react'

import Modal from '@Modal/V3/Modal'

import FormStatus from '@/Form/FormStatus'

import Loader from '@Pure/Loader'

import request from '@function/ajax/request'
import bemit   from '@function/bemit'

import { num, formatNum } from '@root/utility'

const { app, moment } = window;

export default function DepositDetailsModal ({ onClose, id, ...props })
{
	const [status, setStatus] = useState({ });
	const [loading, setLoading] = useState(false);
	const [auto_closing, setAutoClosing] = useState(0);
	const [created, setCreated] = useState(false);
	const [data, setData] = useState();

	const _ref_ctrl = useRef();

	useEffect(function ()
	{
		if (!auto_closing) return;

		const timeout = window.setTimeout(function ()
		{
			setAutoClosing(0);
		},
		auto_closing);

		return () => window.clearTimeout(timeout);
	},
	[auto_closing, onClose]);

// réinitialise la modale une fois masquée pour éviter
// de modifier ce qui est affiché en pleine animation d'ouverture/fermeture
	const handleModalHidden = useCallback(function (params)
	{
		setCreated(false);
		setStatus({ });
	},
	[]);

	const modifiers = useMemo(function ()
	{
		return props.bemit || ['check-deposit'];
	},
	[props.bemit]);

	const prevent_close = loading === 'creating' || auto_closing > 0;

	useEffect(function ()
	{
		if (!id) return;

		(async function fetchChecks ()
		{
			setLoading('fetching');

			try
			{
				var response = await request('/check-deposits/get-one')
				.config({ })
				.post({ id: id });
			}
			catch (update)
			{
				return setStatus(update);
			}
			finally
			{
				setLoading(false);
			}

			setData(response.deposit);
		})();
	},
	[id]);

	const footer = created
	? <FormStatus { ...status } />
	:
	(
		<>
			<FormStatus { ...status } />

			<button type="button" aria-label="Fermer"
				className={ props['close-classes'] || bemit('c-btn', ['grey']) }
				onClick={ exit }>
				Fermer
			</button>

			{
				loading ?
				(
					<Loader className="c-loader" bemit={ ['primary', 'bg-white'] }
						label="Mise à jour..."
					/>
				)
				: undefined
			}

		</>
	);

	const details = (created ? [] : data?._checks || []).map(function (payment)
	{
		return (
			<div className="c-dashboard__row" key={ payment.id }>

				<div className="c-dashboard__cell Payment-date">
					{ moment(payment.createdAt).format('DD/MM/YYYY') }
				</div>

				<div className="c-dashboard__cell Payment-name">
					{ payment.name }
				</div>

				<div className="c-dashboard__cell Payment-number">
					{ payment.number }
				</div>

				<div className="c-dashboard__cell Payment-amount">
					{ payment.amount }€
				</div>

			</div>
		);
	});

	const total = (created ? [] : data?._checks || [])
	.reduce(function (total, payment)
	{
		return num(total + num(payment.amount))
	},
	0);

	const header_row = details.length > 0 ?
	(
		<div className="c-dashboard__row is-header-row">

			<div className="c-dashboard__cell Payment-date">
				Date
			</div>

			<div className="c-dashboard__cell Payment-name">
				Nom
			</div>

			<div className="c-dashboard__cell Payment-number">
				N° de chèque
			</div>

			<div className="c-dashboard__cell Payment-amount">
				Montant
			</div>

		</div>
	)
	: undefined;

	const totals = details.length > 1 ?
	(
		<div className="c-dashboard__row is-transparent">

			<div className="c-dashboard__cell Payment-date" />

			<div className="c-dashboard__cell Payment-name" />

			<div className="c-dashboard__cell Payment-number">
				<div className="u-full-width u-text-right">
					Total&nbsp;:
				</div>
			</div>

			<div className="c-dashboard__cell Payment-amount">
				<strong>{ formatNum(total) }€</strong>
			</div>

		</div>
	)
	: undefined;

	return (
		<Modal open={ props.open === true } onClose={ onClose }
			bemit={ modifiers } trg={ props.trg } footer={ footer }
			title="Remise de chèques"
			prevent-close={ prevent_close }
			afterHidden={ handleModalHidden }>

			{
				data?.number ?
				(
					<div className="u-full-width u-margin-bottom-15">
						Bordereau de chèques n°
						{ ' ' }
						{ data.number }
					</div>
				)
				: undefined
			}

			{ header_row }

			{ details }

			{ totals }

		</Modal>
	);

	function exit (e)
	{
		_ref_ctrl.current?.abort?.();
		setAutoClosing(0);
		onClose(e);
	}
}